import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed } from 'vue';
import axios from 'axios';

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { APIS_INVENTORY } from '@/constants/apis';
import { TOKEN } from '@/constants/labels';

/********************************
 *********** FUNCTION ***********
 *******************************/
import { showConsoleError } from '@/functions/errors';


export default /*#__PURE__*/_defineComponent({
  __name: 'copyComponent',
  props: {
    itemObject   : { required:true, type:Object },
    arraySubtype : { required:true, type:Array },
    arrayType    : { required:true, type:Array },
    arrayMark    : { required:true, type:Array },
    arraySNMP    : { required:true, type:Array }
},
  emits: ['closeCopyDialog'],
  setup(__props, { emit: emits }) {

const props = __props;

const { xs } = useDisplay();

/********************************
 ************ STORE *************
 *******************************/
const store = useStore();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 ********** CONSTANTES **********
 *******************************/


        

const finalItem     = computed(() => props.itemObject);
const finalSubtype  = computed(() => props.arraySubtype);
const finalType     = computed(() => props.arrayType);
const finalMark     = computed(() => props.arrayMark);
const finalSNMP     = computed(() => props.arraySNMP);

const ip            = ref(finalItem.value.ip);
const tag           = ref(finalItem.value.tag);
const mark          = ref(finalItem.value.marca);
const rol           = ref(finalItem.value.rol);
const type          = ref(finalItem.value.tipo);
const snmp_conf     = ref(finalItem.value.snmp_conf??'0');
const anotacion     = ref(finalItem.value.anotacion??'{}');
// const gps           = ref(finalItem.value.gps);
const gps           = ref(finalItem.value.gps??'{"latitud" : 0, "longitud" : 0, "altitud" : 0}');
const valid         = ref(true);
const params        = ref({});


const latitude      = ref(gps.value !== '' ? JSON.parse(gps.value).latitud     : '');
const longitude     = ref(gps.value !== '' ? JSON.parse(gps.value).longitud    : '');
const altitude      = ref(gps.value !== '' ? JSON.parse(gps.value).altitud     : '');

const api           = APIS_INVENTORY.value.postAddInventoryData;

const emitDialogClose = () => {
    emits('closeCopyDialog');
}
        
const addItem = async () => {

    await getParams();

    await axios.post(api,params.value, { headers: { "Authorization": `Bearer ${TOKEN}` } }).then((response) =>{

        if(!response.data.error){

            store.dispatch('getInventoryData'); 
            store.dispatch('showSnackBar', {type: 'setSnackAdd', msg: t('snackbar.add')});

        }
        else{
            showErrorSnackBar('snackbar.errorAdd');
        }
    })
    .catch(function (error) {
        showConsoleError(error);
        showErrorSnackBar('snackbar.errorAdd');
    });
}


const showErrorSnackBar = (errorMsg:string) => {

    store.dispatch('showSnackBar', {type: 'setSnackError', msg: t(`${errorMsg}`)});

}


const getParams = async () => {
    let finalGPS = {
        "latitud"  : parseFloat(latitude.value),
        "longitud" : parseFloat(longitude.value),
        "altitud"  : parseFloat(altitude.value),
    }
    params.value = {
        ip          : ip.value,
        tag         : tag.value,
        marca       : mark.value,
        tipo        : type.value,
        rol         : rol.value,
        snmp_conf   : parseInt(snmp_conf.value),
        anotacion   : anotacion.value,
        gps         : JSON.stringify(finalGPS),
    }
}

const fieldRules    = computed ( () => [ (v:string) => !!v ||  t('labels.error.required') ]);


return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_sheet, {
    color: "bgtopology",
    width: "100%",
    class: "defaultCard"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        class: "ma-0",
        justify: "space-between",
        style: {"align-items":"self-end !important"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "10" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_sheet, { color: "transparent" }, {
                default: _withCtx(() => [
                  _createElementVNode("h2", null, _toDisplayString(_unref(t)('labels.addTitle')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "1" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                icon: "mdi-close",
                variant: "plain",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emitDialogClose()))
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_divider, { class: "mt-4 mb-7" }),
      _createVNode(_component_v_form, {
        modelValue: valid.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((valid).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                class: _normalizeClass(_unref(xs)?'pa-0':null),
                cols: "12",
                sm: "4",
                md: "3",
                lg: "3",
                xl: "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: ip.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ip).value = $event)),
                    label: _unref(t)('labels.ip') + ' *',
                    variant: "underlined",
                    density: "compact",
                    rules: fieldRules.value
                  }, null, 8, ["modelValue", "label", "rules"])
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_v_col, {
                class: _normalizeClass(_unref(xs)?'pa-0':null),
                cols: "12",
                sm: "4",
                md: "3",
                lg: "3",
                xl: "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: tag.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tag).value = $event)),
                    label: _unref(t)('labels.name') + ' *',
                    variant: "underlined",
                    density: "compact",
                    rules: fieldRules.value
                  }, null, 8, ["modelValue", "label", "rules"])
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_v_col, {
                class: _normalizeClass(_unref(xs)?'pa-0':null),
                cols: "12",
                sm: "4",
                md: "3",
                lg: "3",
                xl: "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    modelValue: mark.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((mark).value = $event)),
                    items: finalMark.value,
                    label: _unref(t)('labels.mark')  + ' *',
                    variant: "underlined",
                    density: "compact",
                    rules: fieldRules.value
                  }, null, 8, ["modelValue", "items", "label", "rules"])
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_v_col, {
                class: _normalizeClass(_unref(xs)?'pa-0':null),
                cols: "12",
                sm: "4",
                md: "3",
                lg: "3",
                xl: "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    modelValue: rol.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((rol).value = $event)),
                    items: finalSubtype.value,
                    label: _unref(t)('labels.subtype')  + ' *',
                    variant: "underlined",
                    density: "compact",
                    rules: fieldRules.value
                  }, null, 8, ["modelValue", "items", "label", "rules"])
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_v_col, {
                class: _normalizeClass(_unref(xs)?'pa-0':null),
                cols: "12",
                sm: "4",
                md: "3",
                lg: "3",
                xl: "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    modelValue: type.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((type).value = $event)),
                    items: finalType.value,
                    label: _unref(t)('labels.type')  + ' *',
                    variant: "underlined",
                    density: "compact",
                    rules: fieldRules.value
                  }, null, 8, ["modelValue", "items", "label", "rules"])
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_v_col, {
                class: _normalizeClass(_unref(xs)?'pa-0':null),
                cols: "12",
                sm: "4",
                md: "3",
                lg: "3",
                xl: "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    modelValue: snmp_conf.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((snmp_conf).value = $event)),
                    items: finalSNMP.value,
                    label: _unref(t)('labels.snmp_conf'),
                    variant: "underlined",
                    density: "compact"
                  }, null, 8, ["modelValue", "items", "label"])
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_v_col, {
                class: _normalizeClass(_unref(xs)?'pa-0':null),
                cols: "12",
                sm: "4",
                md: "6",
                lg: "6",
                xl: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: anotacion.value,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((anotacion).value = $event)),
                    label: _unref(t)('labels.annotation'),
                    variant: "underlined",
                    density: "compact"
                  }, null, 8, ["modelValue", "label"])
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_v_col, {
                cols: "12",
                class: "px-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { class: "ma-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "4",
                        md: "3",
                        lg: "3",
                        xl: "3",
                        class: "pa-0 pl-0 pr-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: latitude.value,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((latitude).value = $event)),
                            label: _unref(t)('labels.latitude'),
                            variant: "underlined",
                            density: "compact"
                          }, null, 8, ["modelValue", "label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "4",
                        md: "3",
                        lg: "3",
                        xl: "3",
                        class: "pa-0 px-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: longitude.value,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((longitude).value = $event)),
                            label: _unref(t)('labels.longitude'),
                            variant: "underlined",
                            density: "compact"
                          }, null, 8, ["modelValue", "label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "4",
                        md: "3",
                        lg: "3",
                        xl: "3",
                        class: "pa-0 px-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: altitude.value,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((altitude).value = $event)),
                            label: _unref(t)('labels.altitude'),
                            variant: "underlined",
                            density: "compact"
                          }, null, 8, ["modelValue", "label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            onClick: _cache[11] || (_cache[11] = ($event: any) => (addItem())),
            disabled: (!valid.value && valid.value !== null && valid.value !== undefined),
            class: "mt-10",
            "prepend-icon": "mdi-check-circle",
            color: "success",
            block: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('buttons.add' )), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})